<template>
  <form-group
      :name="name"
      :label="label"
      :help-text="helpText"
      :error="error"
      :label-width="labelWidth"
      :input-width="inputWidth"
  >
    <typeahead-widget
        :placeholder="placeholder"
        :endpoint="endpoint"
        :token="token"
        :params="params"
        :path="path"
        v-model="intermediateValue"
        :result-label-property="resultLabelProperty"
        :result-id-property="resultIdProperty"
        :initial-label="initialLabel"
        :load-initial="loadInitial"
    ></typeahead-widget>
  </form-group>
</template>

<script>
import FormGroup from "./FormGroup";
import TypeaheadWidget from "../Widgets/Typeahead";

export default {
  components: {FormGroup, TypeaheadWidget},

  props: {
    "name": {},
    "label": {},
    "helpText": {"default": null},
    "error": {},
    "labelWidth": {},
    "inputWidth": {},
    "value": [Number, String],
    "resultLabelProperty": {
      type: [String, Function],
      default: 'name'
    },
    "resultIdProperty": {
      type: String,
      default: 'id'
    },
    "initialLabel": String,
    "placeholder": String,
    "endpoint": String,
    "token": String,
    "path": String,
    "params": Object,
    loadInitial: {
      required: false,
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      intermediateValue: this.value
    }
  },

  watch: {
    intermediateValue(newValue) {
      this.$emit('input', newValue)
    },
    value(newValue) {
      this.intermediateValue = newValue
    }
  }
}
</script>
